import io from "socket.io-client";

const serverUrl = process.env.REACT_APP_SERVER_URL || 'http://localhost:4000';
const wsURL = 'ws' + serverUrl.slice(4) + '/team/';

let socket = null;

function getSocket() {
  if (!socket) {
    socket = io.connect(wsURL, {
      reconnectionAttempts: 5,
      reconnectionDelay: 2000,
      timeout: 10000,
    });
    socket.on("connect", () => {});
  }
  return socket;
}

export default getSocket;
